import { Controller } from "@hotwired/stimulus"
import marked from "marked"

export default class extends Controller {
  connect() {
    this.element.innerHTML = marked(this.element.innerHTML)
  }
}